import React, { useEffect, useState } from "react";
import BillboardChart from "react-billboardjs";
import "billboard.js/dist/billboard.css";
import { Box } from "@mui/material";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import { loginState, configState } from "../lib/State";
import pr from "../lib/pr";
import axios from "axios";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import { ko } from "date-fns/locale";
import moment from "moment";
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import add_comma from "../lib/add_comma";

const style = {
  title: {
    fontSize: 18,
    ml: 1,
    mt: 1,
    mb: 1
  }
}

const axis = {
  x: {
    type: "category"
  }
}

const CHART_DATA = {
  x: "x",
  columns: [
    ['x', '무료', '1회권', '4회권', '8회권', '12회권', '20회권', '36회권', '40회권', '60회권'],
    ['data1', 0, 0, 0, 0, 0, 0, 0, 0, 0],
  ],
  type: 'bar',
};

export default function ChartSaleToday(props) {

  const { tcidParent } = props;
  const cid = get_cid();
  const token = get_token();
  const [data, setData] = useState(CHART_DATA);
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [sum, setSum] = useState(0);

  const get_data = async () => {

    // setData({
    //   x: "x",
    //   columns: [
    //     ['x', '무료', '1회권', '4회권', '8회권', '12회권', '20회권', '36회권', '40회권', '60회권'],
    //     ['data1', 1, 10, 100, 0, 0, 0, 0, 0, 0],
    //   ],
    //   type: 'bar',
    // });

    let result = await axios.post(configState.api + '/chart/sale_today', {
      token: token,
      cid: cid,
      tcid: tcidParent,
      date: date,
    });
    console.log(result.data.columns);
    if (result.data.success === 1) {
      setData({
        x: "x",
        columns: [
          ['x', '무료', '1회권', '4회권', '8회권', '12회권', '20회권', '36회권', '40회권', '60회권','정기권'],
          result.data.rows,
        ],
        type: "bar",
      });

      setSum(result.data.sum);
    }

  }

  const leftButton = () => {
    setDate(moment(date).add(-1, 'day').format('YYYY-MM-DD'));
  }

  const rightButton = () => {
    setDate(moment(date).add(1, 'day').format('YYYY-MM-DD'));
  }

  useEffect(() => {
    get_data();
  }, [date, tcidParent]);

  useEffect(() => {
    console.log(data);
  }, [data])

  return (
    <Box width={500}>
      <Box display="flex" alignItems="center">
        <Box marginLeft={3} width={180}> 합계:{add_comma(sum)}</Box>
        <Box display="flex" alignItems="center">
          <Box>
            <IconButton color="primary" aria-label="내일" component="label" onClick={leftButton}>
              <ArrowLeftIcon fontSize="large" />
            </IconButton>
          </Box>
          <Box marginLeft={1}>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
              <DatePicker
                label="날짜선택"
                value={date}
                onChange={(newValue) => {
                  setDate(newValue);
                }}
                renderInput={(params) => <TextField size="small" {...params} />}
              />
            </LocalizationProvider>
          </Box>
          <Box marginLeft={1}>
            <IconButton color="primary" aria-label="내일" component="label" onClick={rightButton}>
              <ArrowRightIcon fontSize="large" />
            </IconButton>
          </Box>
        </Box>
      </Box>
      <Box>
        <BillboardChart data={data} axis={axis} />
      </Box>
    </Box>
  );
}
